const env = (process.env.REACT_APP_STAGE ? process.env.REACT_APP_STAGE : 'dev') as string;

const conf: { [k: string]: any } = {
  all: {
    USER_MANAGEMENT_SITE: 'LCAB',
    X_CLIENT_SOURCE: 'classified:lcab:depot-web',
    TEMPLATE_RESET_PASSWORD: '000CXQ',
    SENTRY_DSN: 'https://bfe17253899442e7aff522387544ed05@o86572.ingest.sentry.io/5411972',
    SENTRY_ENV: env,
    AT_COLLECT_DOMAIN: 'ressources.centraleauto.com',
    APPNEXUS_SITE_ID: 6949,
    APPNEXUS_SITE_NAME: 'Lacentrale',
    PBX_HMAC_KEY: process.env.REACT_APP_PBX_HMAC_KEY || 'H KEY NOT FOUND',
    PBX_LC_KEY: process.env.REACT_APP_PBX_LC_KEY || 'LC KEY NOT FOUND',
    PBX_LC_LOGIN: process.env.REACT_APP_PBX_LC_LOGIN || 'LOGIN NOT FOUND',
    PBX_LC_SITE: process.env.REACT_APP_PBX_LC_SITE || 'SITE NOT FOUND',
    PBX_LC_RANK: '01',
    PBX_ALGORITHM: 'SHA512',
    PBX_SIGNATURE: 'Sign',
    PBX_RETOUR: 'transactionID:R;amount:M;t:T;a:A;h:H;payboxId:S;d:D;errorCode:E',
    PBX_DEVISE: '978',
    PBX_REFUSE: 'paiement_refus.php',
    PBX_ANNULE: 'paiement_annul.php',
    PBX_EFFECTUE: 'paiement_accept.php',
    PBX_REPONDRE_A: 'v1/validate-paybox-payment',
    URL_AWS_S3: 'https://s3.eu-west-1.amazonaws.com/',
  },
  dev: {
    AT_TRACKING_ID: 601454,
    URL_LACENTRALE: 'https://dev.lacentrale.fr/',
    URL_PILOT: 'https://pilot.dev.lacentrale.fr/',
    URL_LEGACY_DEPOSIT: 'https://depot.dev.lacentrale.fr/',
    URL_USER_MANAGEMENT: 'https://user-management.dev-carboatservices.fr/',
    URL_RESET_PASSWORD:
      'http://dev.lacentrale.fr/auth.php?callback=http%3A%2F%2Fdev.lacentrale.fr/reset-password.php&fallback=http%3A%2F%2Fdev.lacentrale.fr/reset-password.php%3Fusername={{username}}%26expired=1&jwt={{jwt}}&xtor=EPR-301122130-[Oubli_motdepasse]-20190809-[Se_connecter]--',
    COOKIE_DOMAIN: '.dev.lacentrale.fr',
    URL_VALID_IMMAT: 'https://ngc-gate.dev-carboatservices.fr/',
    URL_CLASSIFIEDS_API: 'https://annonce.dev-carboatservices.fr/',
    URL_GEOLOC_API: 'https://geoloc.dev.lacentrale.fr/',
    URL_MATCH_IMMAT: 'https://dab-matching-ws.dev-carboatservices.fr/',
    URL_VEHICLE_REFERENTIAL: 'https://dab-ws.dev-carboatservices.fr/',
    URL_VEHICLE_DESCRIPTION: 'https://equipments-options-packs.dev-carboatservices.fr/public/',
    URL_CLASSIFIED_MANAGEMENT: 'https://classified-management.dev-carboatservices.fr/',
    URL_OFFERS: 'https://offers.dev-carboatservices.fr/',
    URL_PHONE_VALIDATION: 'https://phone-validator.dev-carboatservices.fr/',
    URL_NORMALIZED_VALIDATION: 'https://validation.dev-carboatservices.fr/',
    URL_DEPOSIT_PICTURES: 'https://deposit-pictures-upload.dev-carboatservices.fr/',
    URL_LABELO: 'https://labelo.dev-carboatservices.fr/',
    URL_INVOICES: 'https://invoices.dev-carboatservices.fr/',
    URL_PAYBOX_MAIN: 'https://preprod-tpeweb.paybox.com/',
    URL_PAYBOX_FALLBACK: 'https://preprod-tpeweb.paybox.com/',
    URL_IMAGES_LC: 'https://image.dev.lacentrale.fr/',
    ALLOW_MOTO: true,
    ALLOW_LOISIR: true,
  },
  test: {
    AT_TRACKING_ID: 601454,
    URL_LACENTRALE: 'https://test.lacentrale.fr/',
    URL_PILOT: 'https://pilot.test.lacentrale.fr/',
    URL_LEGACY_DEPOSIT: 'https://depot.test.lacentrale.fr/',
    URL_USER_MANAGEMENT: 'https://user-management.test-carboatservices.fr/',
    URL_RESET_PASSWORD:
      'http://test.lacentrale.fr/auth.php?callback=http%3A%2F%2Ftest.lacentrale.fr/reset-password.php&fallback=http%3A%2F%2Ftest.lacentrale.fr/reset-password.php%3Fusername={{username}}%26expired=1&jwt={{jwt}}&xtor=EPR-301122130-[Oubli_motdepasse]-20190809-[Se_connecter]--',
    COOKIE_DOMAIN: '.test.lacentrale.fr',
    URL_VALID_IMMAT: 'https://ngc-gate.test-carboatservices.fr/',
    URL_CLASSIFIEDS_API: 'https://annonce.test-carboatservices.fr/',
    URL_GEOLOC_API: 'https://geoloc.test.lacentrale.fr/',
    URL_MATCH_IMMAT: 'https://dab-matching-ws.test-carboatservices.fr/',
    URL_VEHICLE_REFERENTIAL: 'https://dab-ws.test-carboatservices.fr/',
    URL_VEHICLE_DESCRIPTION: 'https://equipments-options-packs.test-carboatservices.fr/public/',
    URL_CLASSIFIED_MANAGEMENT: 'https://classified-management.test-carboatservices.fr/',
    URL_OFFERS: 'https://offers.test-carboatservices.fr/',
    URL_PHONE_VALIDATION: 'https://phone-validator.test-carboatservices.fr/',
    URL_NORMALIZED_VALIDATION: 'https://validation.test-carboatservices.fr/',
    URL_DEPOSIT_PICTURES: 'https://deposit-pictures-upload.test-carboatservices.fr/',
    URL_LABELO: 'https://labelo.test-carboatservices.fr/',
    URL_INVOICES: 'https://invoices.test-carboatservices.fr/',
    URL_PAYBOX_MAIN: 'https://preprod-tpeweb.paybox.com/',
    URL_PAYBOX_FALLBACK: 'https://preprod-tpeweb.paybox.com/',
    URL_IMAGES_LC: 'https://image.test.lacentrale.fr/',
    ALLOW_MOTO: true,
    ALLOW_LOISIR: true,
  },
  prod: {
    AT_TRACKING_ID: 251312,
    URL_LACENTRALE: 'https://www.lacentrale.fr/',
    URL_PILOT: 'https://pilot.lacentrale.fr/',
    URL_LEGACY_DEPOSIT: 'https://depot.lacentrale.fr/',
    URL_USER_MANAGEMENT: 'https://user-management.carboatservices.fr/',
    URL_RESET_PASSWORD:
      'http://www.lacentrale.fr/auth.php?callback=http%3A%2F%2Fwww.lacentrale.fr/reset-password.php&fallback=http%3A%2F%2Fwww.lacentrale.fr/reset-password.php%3Fusername={{username}}%26expired=1&jwt={{jwt}}&xtor=EPR-301122130-[Oubli_motdepasse]-20190809-[Se_connecter]--',
    COOKIE_DOMAIN: '.lacentrale.fr',
    URL_VALID_IMMAT: 'https://ngc-gate.carboatservices.fr/',
    URL_CLASSIFIEDS_API: 'https://annonce.carboatservices.fr/',
    URL_GEOLOC_API: 'https://geoloc.lacentrale.fr/',
    URL_MATCH_IMMAT: 'https://dab-matching-ws.carboatservices.fr/',
    URL_VEHICLE_REFERENTIAL: 'https://dab-ws.carboatservices.fr/',
    URL_VEHICLE_DESCRIPTION: 'https://equipments-options-packs.carboatservices.fr/public/',
    URL_CLASSIFIED_MANAGEMENT: 'https://classified-management.carboatservices.fr/',
    URL_OFFERS: 'https://offers.carboatservices.fr/',
    URL_PHONE_VALIDATION: 'https://phone-validator.carboatservices.fr/',
    URL_NORMALIZED_VALIDATION: 'https://validation.carboatservices.fr/',
    URL_DEPOSIT_PICTURES: 'https://deposit-pictures-upload.carboatservices.fr/',
    URL_LABELO: 'https://labelo.carboatservices.fr/',
    URL_INVOICES: 'https://invoices.carboatservices.fr/',
    URL_PAYBOX_MAIN: 'https://tpeweb.paybox.com/',
    URL_PAYBOX_FALLBACK: 'https://tpeweb1.paybox.com/',
    URL_IMAGES_LC: 'https://image.lacentrale.fr/',
    ALLOW_MOTO: true,
    ALLOW_LOISIR: false,
  },
};

export const config: { [k: string]: any } = { ...conf.all, ...conf[env] };
